export const CLICK_TRACKING_EVENT_DESCRIPTIONS = {
    PHYSICAL: 'ThemedSearch_annualphysical',
    ALLERGIST: 'ThemedSearch_allergies',
    THERAPIST: 'ThemedSearch_mentalhealth',
    FLU_SHOT: 'ThemedSearch_flushot',
};
